/* src/app/shared/components/carrier-logo/carrier-logo.component.scss */
.logo.ups {
  width: 1.5625rem;
}
.logo.fedex {
  width: 3.125rem;
}
:host(.carrier-logo) {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  justify-content: center;
  width: 100%;
  height: auto;
}
/*# sourceMappingURL=carrier-logo.component.css.map */
